import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "crime-profile",
  ref: "root"
}
const _hoisted_2 = {
  key: 0,
  class: "placeholder-glow",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 1,
  class: "text-muted mb-0"
}
const _hoisted_4 = {
  key: 2,
  class: "text-muted mb-0"
}
const _hoisted_5 = { class: "row g-4" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "border-top mt-4 pt-3" }
const _hoisted_12 = { class: "row g-4 align-items-center" }
const _hoisted_13 = { class: "col-lg-8" }
const _hoisted_14 = { class: "crime-profile__help list-unstyled row g-2 mb-2" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "col-lg-4" }
const _hoisted_17 = { class: "crime-profile__map-cta" }
const _hoisted_18 = ["data-bs-target", "aria-controls"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state === 'loading')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
          _createStaticVNode("<div class=\"row g-4\"><div class=\"col-lg-6\"><span class=\"placeholder col-5 mb-2\"></span><span class=\"placeholder crime-profile__placeholder w-100 rounded mb-3\"></span><span class=\"placeholder col-8 mb-2\"></span><span class=\"placeholder col-6\"></span></div><div class=\"col-lg-6\"><span class=\"placeholder col-7 mb-2\"></span><span class=\"placeholder crime-profile__placeholder w-100 rounded mb-3\"></span><span class=\"placeholder col-9 mb-2\"></span><span class=\"placeholder col-8\"></span></div></div>", 1)
        ]))]))
      : (_ctx.state === 'failed')
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Údaje o kriminalitě se nepodařilo načíst."))
        : (_ctx.area === null)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Pro místo nemovitosti nemáme údaje o kriminalitě."))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", { innerHTML: _ctx.head }, null, 8, _hoisted_7),
                  (_ctx.hero !== '')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "mb-3",
                        innerHTML: _ctx.hero
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", { innerHTML: _ctx.facts }, null, 8, _hoisted_9)
                ]),
                (_ctx.breakdown !== '')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "col-lg-6",
                      innerHTML: _ctx.breakdown
                    }, null, 8, _hoisted_10))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("ul", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.help, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: item.lead,
                          class: "col-md-6"
                        }, [
                          _createElementVNode("strong", null, _toDisplayString(item.lead), 1),
                          _createTextVNode(" " + _toDisplayString(item.text), 1)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", { innerHTML: _ctx.attribution }, null, 8, _hoisted_15)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "crime-profile__map-cta-title" }, "Jak vypadá kriminalita kolem?", -1)),
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "crime-details__meta mb-3" }, " Index sousedních oblastí, jednotlivé skutky za posledních 12 měsíců a letecký snímek místa. ", -1)),
                      (_ctx.unfoldMapId !== null)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-primary",
                            "data-bs-toggle": "collapse",
                            "data-bs-target": '#' + _ctx.unfoldMapId,
                            "aria-controls": _ctx.unfoldMapId,
                            "aria-expanded": "false"
                          }, [...(_cache[2] || (_cache[2] = [
                            _createElementVNode("i", { class: "fas fa-map-marker-alt me-2" }, null, -1),
                            _createTextVNode("Zobrazit mapu kriminality okolí ", -1)
                          ]))], 8, _hoisted_18))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-primary",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openMap && _ctx.openMap(...args)))
                          }, [...(_cache[3] || (_cache[3] = [
                            _createElementVNode("i", { class: "fas fa-map-marker-alt me-2" }, null, -1),
                            _createTextVNode("Otevřít mapu kriminality okolí ", -1)
                          ]))]))
                    ])
                  ])
                ])
              ])
            ], 64))
  ], 512))
}